import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { OwnerPasswordResetConsumeRequest } from '@naya/shared'
import { ownerApi } from '../ownerApi.js'
import { ownerMeKey } from './useOwnerSession.js'
import type {
  PasswordResetConsumeResponse,
  PasswordResetValidateResponse,
} from '../types.js'

export function usePasswordResetValidate(token: string | undefined) {
  return useQuery<PasswordResetValidateResponse>({
    queryKey: ['owner', 'password-reset', 'validate', token],
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
    queryFn: () =>
      ownerApi.get<PasswordResetValidateResponse>(
        `/owner/password-reset/validate?token=${encodeURIComponent(token!)}`,
      ),
  })
}

export function usePasswordResetConsume() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: OwnerPasswordResetConsumeRequest) =>
      ownerApi.post<PasswordResetConsumeResponse>(
        '/owner/password-reset/consume',
        input,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ownerMeKey })
    },
  })
}
